import {Component, OnInit, ViewChild} from '@angular/core';
import {Planter} from '../../../../models/planter.model';
import {MatTableDataSource, MatSort, MatDialog, MatPaginator} from '@angular/material';
import {GeneralService} from '../../../../services/general/general.service';
import {ConceptValues} from '../../../../models/concept-values.model';
import {Concept} from '../../../../models/concept.model';
import {PlanterService} from '../../../../services/planter/planter.service';
import {PlanterFormModalComponent} from '../../../../components/modals/planter-form-modal/planter-form-modal.component';
import {LoadService} from '../../../../components/loader/loader.service';
import {Router} from '../../../../../../node_modules/@angular/router';
import {Member} from '../../../../models/member.model';
import {AlertComponent} from '../../../../components/alert/alert.component';

@Component({
    selector: 'app-planters-list',
    templateUrl: './planters-list.component.html',
    styleUrls: ['./planters-list.component.scss']
})
export class PlantersListComponent implements OnInit {
    // Defines if all the needed resources has load
    resourcesHasLoaded: boolean = false;

    isAuthorized = true;
    allPlanters: Planter[] = [];
    planterStates: ConceptValues;
    planterStateValue: string = 'Todos';
    planterStateObjValue: ConceptValues;
    fulfillmentStates: ConceptValues;
    fulfillmentStateValue: string = 'Todos';
    inputFilterValue: string;

    displayedColumns = ['name', 'church', 'state', 'fulfillment', 'group'];
    dataSource = new MatTableDataSource(this.allPlanters);

    loader: any;
    isModalOpen: boolean = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(private planterService: PlanterService,
                private generalService: GeneralService,
                public dialog: MatDialog,
                private loadService: LoadService,
                private router: Router) {
        this.loadConcepts();
        this.loadPlanters();
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    loadConcepts() {
        this.planterStates = this.generalService.concepts[5];
        if (this.planterStates == null) {
            this.generalService.getConceptDataById(5).subscribe((data: Concept) => {
                this.planterStates = data.values;
                this.generalService.concepts[5] = data.values;
            });
        }

        this.fulfillmentStates = this.generalService.concepts[7];
        if (this.fulfillmentStates == null) {
            this.generalService.getConceptDataById(7).subscribe((data: Concept) => {
                this.fulfillmentStates = data.values;
                this.generalService.concepts[7] = data.values;
            });
        }
    }

    loadPlanters() {
        this.planterService.getPlanters().subscribe(
            (data: Planter[]) => {
                this.allPlanters = data;
                this.allPlanters.forEach(planter => {
                    this.generalService.planters[planter.id] = planter;
                });

                this.dataSource = new MatTableDataSource(this.allPlanters);

                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;

                this.resourcesHasLoaded = true;
            },
            (error) => {
                console.log('error', error);
                this.isAuthorized = false;
                this.resourcesHasLoaded = true;
            });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    applyPlanterStateFilter(filterStateValue: ConceptValues) {
        this.planterStateObjValue = filterStateValue;
        this.dataSource.filter = '';
        this.dataSource.filter = filterStateValue.value;
    }

    applyFullfilmentStateFilter(filterStateValue: ConceptValues) {
        this.dataSource.filter = '';
        this.dataSource.filter = filterStateValue.value;
    }

    clearFilters() {
        this.dataSource.filter = '';
        this.planterStateValue = '';
        this.fulfillmentStateValue = '';
        this.inputFilterValue = '';
        this.planterStateObjValue = undefined;
    }

    clearFulfillmentFilter() {
        this.fulfillmentStateValue = '';
        this.inputFilterValue = '';
        if(this.planterStateObjValue === undefined) {
            this.clearFilters();
        } else {
            this.applyPlanterStateFilter(this.planterStateObjValue);
        }
    }

    loadModalChangeStatePlanter(planterState: ConceptValues, planterId: number) {
        const dialogRef = this.dialog.open(PlanterFormModalComponent, {
            height: 'auto',
            minHeight: '63vh',
            disableClose: true,
            data: {
                title: planterState.description,
                subtitle: 'Comentarios sobre el estado de la postulación',
                planter: planterId
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            this.isModalOpen = false;
            if (response != undefined) {
                this.loader = this.loadService.createLoad('');
                this.loader.open();
                const user: Member = JSON.parse(localStorage.getItem('user'));

                let dataRq = {
                    cause: planterState.value,
                    description: response.description,
                    seeder_id: planterId,
                    user_id: Number(user.id)
                };
                console.log('dataRq', dataRq);

                this.planterService.planterObservations(dataRq).subscribe((data) => {
                    console.log('dataRp', data);
                    this.loader.close();
                    this.router.navigate(['/admin', 'extension', 'planter-list']);
                }, (error) => {
                    console.log('error', error);
                    this.loader.close();
                    this.loadErrorModalChangeStatePlanter('No se pudo realzar el cambio de estado');
                });
            }
        });
    }

    loadErrorModalChangeStatePlanter(errorMessage: string) {
        let data = {
            title: 'Atención',
            content: errorMessage
        }

        this.dialog.open(AlertComponent, {
            width: '35vw',
            disableClose: true,
            data: data
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/extension/planters-list/planters-list.component.ts